/* eslint-disable react/prop-types */
import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {makeSelectBasicUser, makeSelectIsAuthenticated} from 'reducers/selectors/userSelectors';
import {getMigratedPortal} from 'utils/migratedPortal';
import MigratedPortalRedirect from './MigratedPortalRedirect';

const isAuthenticatedSelector = makeSelectIsAuthenticated();
const basicUserSelector = makeSelectBasicUser();

export default function PrivateRoute({component: Component, allow, ...rest}) {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const userDetails = useSelector(basicUserSelector);
  const roles = userDetails ? userDetails.roles : [];

  const hasRolePermission =
    roles && roles.some(role => allow && allow.includes(role.title));
  const hasPermission = !allow || hasRolePermission;
  const migratedPortal = getMigratedPortal(userDetails);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          migratedPortal ? (
            <MigratedPortalRedirect portal={migratedPortal} location={props.location} />
          ) : hasPermission ? (
            <Component {...props} />
          ) : (
            <Redirect to="/" />
          )
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: {from: props.location},
            }}
          />
        )
      }
    />
  );
}
